// バックエンドの job_types テーブル（backend/db/seeds/job_types.rb）と手動同期するハードコード定数。
// SSR/CSR の整合性とチップ表示の安定性を優先しているため。seed 変更時は本ファイルも更新する。
//
// label_ja は質問バッジ（「〜向け」）と練習・面接のフィルタチップという狭い領域に出るため、
// 正式ラベルから括弧書きの補足と列挙の後半を落とした短縮形を持つ（lib/company/candidates.ts と同じ規則）。
// 対象範囲まで示す正式ラベルは profile/page.tsx（希望職種の選択）と backend のプロンプト側にある。

export interface JobType {
  key: string;
  label_ja: string;
  position: number;
}

export const JOB_TYPES: JobType[] = [
  { key: "engineer", label_ja: "エンジニア", position: 10 },
  { key: "rd_engineer", label_ja: "研究・開発", position: 20 },
  { key: "construction", label_ja: "建築・土木", position: 30 },
  { key: "scm", label_ja: "生産管理・物流", position: 40 },
  { key: "sales", label_ja: "営業", position: 50 },
  { key: "sales_service", label_ja: "販売・接客", position: 60 },
  { key: "marketer", label_ja: "マーケティング・広報", position: 70 },
  { key: "planning", label_ja: "経営企画", position: 80 },
  { key: "consultant", label_ja: "コンサル・士業", position: 90 },
  { key: "finance", label_ja: "財務・経理", position: 100 },
  { key: "hr", label_ja: "人事・総務", position: 110 },
  { key: "office", label_ja: "事務", position: 120 },
  { key: "designer", label_ja: "クリエイティブ", position: 130 },
  { key: "medical_welfare", label_ja: "医療・福祉", position: 140 },
  { key: "public", label_ja: "公務員・教員", position: 150 },
  { key: "other", label_ja: "その他", position: 999 },
];

export function getJobTypeLabel(key: string): string {
  return JOB_TYPES.find((j) => j.key === key)?.label_ja ?? key;
}
